<template>
  <div class="home">
    <div v-if="isLoggedIn"> 
      <Navbar></Navbar>
    </div>
    <div v-else>
      <Hero />

      <login></login>
    </div>

   
  </div>
</template>

<script>
import { fb, db } from "../firebase";

const { auth } = fb;
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
//import Products from "@/sections/Products.vue";
import Login from "@/components/Login.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "home",
  components: {
    Hero,
    Login,
    Navbar
    //Products
  },
  data() {
    return {
      isLoggedIn: auth.currentUser
    }
  },
  mounted() {

     fb.auth().onAuthStateChanged((user) => {
       if(user) {
          this.isLoggedIn = user;
       }
    });
  }
};
</script>

<style>
</style>